import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';
import { SkeletonLine } from '../../ui/Skeleton/SkeletonLine';

const ROWS_PER_DAY = [2, 1];

// Mirrors the forecast's day groups — weekday heading, then hairline-separated rows — at their real heights.
export const RelanceForecastSkeleton: React.FC = () => (
    <div data-testid="relance-forecast-skeleton" aria-hidden="true" className="flex flex-col gap-2xl">
        {ROWS_PER_DAY.map((rows, day) => (
            <div key={day} className="flex flex-col gap-s">
                <SkeletonLine lineClassName="text-s" className="w-36" />
                <div>
                    {Array.from({ length: rows }, (_, i) => (
                        <div key={i} className="flex items-center gap-xl pl-xs pr-0.5 py-m border-line-subtle not-first:border-t">
                            <SkeletonLine lineClassName="flex-1 text-s" className="w-1/3" />
                            <SkeletonBar className="h-5 w-12 shrink-0" />
                            <SkeletonBar className="h-3 w-20 shrink-0" />
                        </div>
                    ))}
                </div>
            </div>
        ))}
    </div>
);
